import { Component } from '@angular/core';

@Component({
  selector: 'my-app-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent {}



// WEBPACK FOOTER //
// ./src/app/layout/layout.component.ts